/* eslint-disable*/
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { Button, Form, Input, Checkbox, Menu, Select } from "antd";
import DataTable from "../../../../../../../components/Layout/Table/DataTable";
import DeleteUserModal from "../../../../../../../components/Layout/DeleteModel/DeleteUserModal";
import CreateUpdateRentRoll from "../../CreateUpdateRentRoll";

const { Option } = Select;

function EditableCell({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) {
  const inputNode =
    inputType === "statusDropdown" ? (
      <Select placeholder="Select" allowClear>
        <Option value="1">LET</Option>
        <Option value="2">VACANT</Option>
        <Option value="3">VACANTS</Option>
        <Option value="4">GUARANTEE</Option>
      </Select>
    ) : inputType === "groupDropdown" ? (
      <Select placeholder="Select" allowClear>
        <Option value="1">Office</Option>
        <Option value="2">Residential</Option>
        <Option value="3">Retail</Option>
        <Option value="4">Hotel</Option>
        <Option value="5">Logistics</Option>
      </Select>
    ) : inputType === "useDropdown" ? (
      <Select placeholder="Select" allowClear>
        <Option value="1">Office</Option>
        <Option value="2">Surgery</Option>
        <Option value="3">Retail</Option>
        <Option value="4">Banking hall</Option>
        <Option value="5">Residential</Option>
        <Option value="6">Restaurant</Option>
        <Option value="7">Warehouse</Option>
        <Option value="8">Storage</Option>
        <Option value="9">Hotel</Option>
        <Option value="10">Other</Option>
        <Option value="11">&apos;--</Option>
        <Option value="12">Parking external</Option>
        <Option value="13">Parking internal</Option>
        <Option value="14">Antenna</Option>
        <Option value="15">Advertisements</Option>
        <Option value="16">Other (per unit)</Option>
      </Select>
    ) : (
      <Input type={inputType} />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: false,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
}
function BasicData({ sethideTableColumns, activeKey }) {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [addUpdateNewRentRoll, setAddUpdateNewRentRoll] = useState(false);
  const [deleteUserModal, setDeleteUserModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [toggle, setToggle] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.key);
  };

  const [dataSource, setDataSource] = useState([
    {
      key: 1,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Abu Dhabi Tourism Authority",
      description1: "3060101777",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Office",
      area: "110.00",
    },
    {
      key: 2,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Albrecht GmbH",
      description1: "3056006849",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Office",
      area: "319.20",
    },
    {
      key: 3,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Albrecht GmbH",
      description1: "3056006849",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Parking Internal",
      area: "1.00",
    },
    {
      key: 4,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Albrecht GmbH",
      description1: "3056006849",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Retail",
      area: "71.72",
    },
    {
      key: 5,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "J Choo Germany GmbH",
      description1: "3060101544",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Retail",
      area: "86.86",
    },
    {
      key: 6,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "J Choo Germany GmbH",
      description1: "3060101545",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Storage",
      area: "69.09",
    },
    {
      key: 7,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "MLV Medizinische Logistik u.Verwaltungsgesellschaft mbH",
      description1: "3060101764",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Parking Internal",
      area: "1.00",
    },
    {
      key: 8,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "MLV Medizinische Logistik u.Verwaltungsgesellschaft mbH",
      description1: "3060101463",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Office",
      area: "214.44",
    },
    {
      key: 9,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "MLV Medizinische Logistik u.Verwaltungsgesellschaft mbH",
      description1: "3060101464",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Office",
      area: "214.44",
    },
    {
      key: 10,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "One & Only Resorts GmbH",
      description1: "3060101808",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Office",
      area: "104.44",
    },
    {
      key: 11,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Paule Ka SAS GmbH",
      description1: "3060101749",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Retail",
      area: "172.72",
    },
    {
      key: 12,
      no: "1",
      pid: "01",
      status: "LET",
      tenantName: "Paule Ka SAS GmbH",
      description1: "3060101749",
      description2: " ",
      location: " ",
      useGroup: " ",
      use: "Storage",
      area: "72.29",
    },
  ]);

  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setDataSource(newData);
        setEditingKey("");
      } else {
        newData.push(row);
        setDataSource(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const initialColState = [
    {
      id: 1,
      title: "PID",
      dataIndex: "pid",
      hidden: false,
    },
    {
      id: 2,
      title: "Status/Type",
      dataIndex: "status",
      // hidden: toggle.includes("status"),
      // editable: true,
      // onCell: (record) => ({
      //   record,
      //   inputType: "statusDropdown",
      //   dataIndex: "status",
      //   title: "Status/Type",
      //   editing: isEditing(record),
      // }),
    },
    {
      id: 3,
      title: "Tenant Name",
      dataIndex: "tenantName",
      hidden: toggle.includes("tenantName"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: "tenantName",
        title: "Tenant Name",
        editing: isEditing(record),
      }),
    },
    {
      id: 4,
      title: "Description#1",
      dataIndex: "description1",
      hidden: toggle.includes("description1"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: "description1",
        title: "Description#1",
        editing: isEditing(record),
      }),
    },
    {
      id: 5,
      title: "Description#2",
      dataIndex: "description2",
      hidden: toggle.includes("description2"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: "description2",
        title: "Description#2",
        editing: isEditing(record),
      }),
    },
    {
      id: 6,
      title: "Location/Floor",
      dataIndex: "location",
      hidden: toggle.includes("location"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: "location",
        title: "Location/Floor",
        editing: isEditing(record),
      }),
    },
    {
      id: 7,
      title: "Use Group",
      dataIndex: "useGroup",
      hidden: toggle.includes("useGroup"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "groupDropdown",
        dataIndex: "useGroup",
        title: "Use Group",
        editing: isEditing(record),
      }),
    },
    {
      id: 8,
      title: "Use",
      dataIndex: "use",
      hidden: toggle.includes("use"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "useDropdown",
        dataIndex: "use",
        title: "Use",
        editing: isEditing(record),
      }),
    },
    {
      id: 9,
      title: "Area/Unit",
      dataIndex: "area",
      hidden: toggle.includes("area"),
      editable: true,
      onCell: (record) => ({
        record,
        inputType: "number  ",
        dataIndex: "area",
        title: "Area/Unit",
        editing: isEditing(record),
      }),
    },
    {
      id: 10,
      title: "Action",
      dataIndex: "Action",
      hidden: false,
      width: "10%",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span className="d-flex align-items-center justify-content-center">
            <div
              role="presentation"
              className="m-0 mr-2 drawer-action-icons cursor-pointer"
              onClick={() => cancel()}
            >
              <MdDelete size={20} />
            </div>
            <div
              className="m-0 drawer-action-icons cursor-pointer"
              role="presentation"
              onClick={() => save(record.key)}
            >
              <FaCheck size={20} />
            </div>
          </span>
        ) : (
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="drawer-action-icons d-flex align-items-center cursor-pointer"
              role="presentation"
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
            >
              <MdModeEdit size={20} />
            </div>
          </div>
        );
      },
    },
  ];

  const handleReset = () => {
    setToggle([]);
  };
  const handleChange = (e) => {
    const checked = e.target.checked;
    const value = e.target.value;
    if (checked) {
      setToggle((prev) => [...prev, value]);
    } else {
      setToggle((prev) => prev.filter((item) => item !== value));
    }
  };

  const basicDatahideTableColumns = (
    <Menu
      items={[
        {
          key: 1,
          type: "group",
          label: (
            <div>
              <h4 style={{ color: "#000" }}>Hide table columns</h4>
            </div>
          ),
        },
        // {
        //   key: 2,
        //   label: (
        //     <Checkbox
        //       value="status"
        //       name="Status/Type"
        //       id={2}
        //       // checked={checkList.includes("valDate")}
        //       // onChange={handleChange}
        //     >
        //       Status/Type
        //     </Checkbox>
        //   ),
        // },
        {
          key: 3,
          label: (
            <Checkbox
              value="tenantName"
              name="Tanent Name"
              id={3}
              // checked={checkList.includes("projectNo")}
              onChange={handleChange}
            >
              Tanent Name
            </Checkbox>
          ),
        },
        {
          key: 4,
          label: (
            <Checkbox
              value="description1"
              name="Description#1"
              id={4}
              // checked={checkList.includes("projectName")}
              onChange={handleChange}
            >
              Description#1
            </Checkbox>
          ),
        },
        {
          key: 5,
          label: (
            <Checkbox
              value="description2"
              name="Description#2"
              id={5}
              // checked={checkList.includes("nameOfClient1")}
              onChange={handleChange}
            >
              Description#2
            </Checkbox>
          ),
        },
        {
          key: 6,
          label: (
            <Checkbox
              value="location"
              name="Location/Floor"
              id={6}
              // checked={checkList.includes("nameOfClient2")}
              onChange={handleChange}
            >
              Location/Floor
            </Checkbox>
          ),
        },
        {
          key: 7,
          label: (
            <Checkbox
              value="useGroup"
              name="Use Group"
              id={7}
              // checked={checkList.includes("instruction")}
              onChange={handleChange}
            >
              Use Group
            </Checkbox>
          ),
        },
        {
          key: 8,
          label: (
            <Checkbox
              value="use"
              name="Use"
              id={8}
              // checked={checkList.includes("scope")}
              onChange={handleChange}
            >
              Use
            </Checkbox>
          ),
        },
        {
          key: 9,
          label: (
            <Checkbox
              value="area"
              name="Area/Unit"
              id={9}
              // checked={checkList.includes("scope")}
              onChange={handleChange}
            >
              Area/Unit
            </Checkbox>
          ),
        },
        {
          key: 10,
          label: (
            <div>
              <hr style={{ border: "1px solid #F2F3F5" }} />
              <Button className="reset-dropdown-btn" onClick={handleReset}>
                Reset
              </Button>
            </div>
          ),
        },
      ]}
    />
  );

  const AddUpdateNewRentRollcloseModal = () => {
    setAddUpdateNewRentRoll(false);
  };

  const closeDeleteUserModal = () => {
    setDeleteUserModal(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    sethideTableColumns(basicDatahideTableColumns);
  }, [activeKey]);

  return (
    <>
      <Form form={form} component={false}>
        <DataTable
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          rowClassName={() => "editable-row"}
          columns={initialColState.filter((item) => item.hidden === false)}
          dataSource={[...dataSource]}
          pagination="true"
          className="antd-table-striped"
          rowSelection={rowSelection}
        />
      </Form>
      <div className="table-count">
        <h5 className="table-count-content">Showing 1 to 9 of 120 entries</h5>
      </div>
      {/* <Row gutter={24}>
        <Col xs={24}>
          <div className="table-footer-btn d-flex align-items-center">
            <div className="align-items-center bg-white d-flex justify-content-between rounded-sm btn-action-div">
              <Button
                className="btn-action d-flex justify-content-center align-items-center text-danger"
                onClick={() => setDeleteUserModal(true)}
                disabled={selectedRowKeys?.length === 0 ? "true" : false}
              >
                <div className="active-action d-flex align-items-center">
                  <MdDelete />
                  <h5 className="mb-0 ml-1 mt-1 text-danger">Delete</h5>
                </div>
              </Button>

              {selectedRowKeys?.length > 1 ? (
                ""
              ) : (
                <>
                  <Divider type="vertical" />
                  <Button
                    className="btn-action d-flex justify-content-center align-items-center"
                    onClick={() => setAddUpdateNewRentRoll(true)}
                    disabled={selectedRowKeys?.length === 0 ? "true" : false}
                  >
                    <div className="active-action d-flex align-items-center">
                      <MdModeEdit className="mt-1" />
                      <h5 className="mb-0 ml-1 mt-1 ">Edit</h5>
                    </div>
                  </Button>
                </>
              )}
            </div>
             <Button className="btn-cancel py-2">
                <h5 className="mb-0">Cancel</h5>
              </Button> 
          </div>
        </Col>
      </Row> */}
      <DeleteUserModal
        visible={deleteUserModal}
        handleCancel={closeDeleteUserModal}
        user="Asset"
      />
      <CreateUpdateRentRoll
        visible={addUpdateNewRentRoll}
        handleCancel={AddUpdateNewRentRollcloseModal}
      />
    </>
  );
}
export default BasicData;

EditableCell.propTypes = {
  editing: PropTypes.node.isRequired,
  dataIndex: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  inputType: PropTypes.node.isRequired,
  record: PropTypes.node.isRequired,
  index: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

BasicData.propTypes = {
  sethideTableColumns: PropTypes.node.isRequired,
  activeKey: PropTypes.node.isRequired,
};
